import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

type Channel = {
    Id: number;
    Code: string;
    Name: string;
    Url: string;
    Configuration: any;
    IsEnabled: boolean;
};

type ChannelCustomerOperation = {
    Id: number;
    ChannelId: number;
    CustomerOperationId: number;
    Url: string;
    Configuration: any;
    IsEnabled: boolean;
};

export interface AddChannelPagePageOptions extends PageOptionsBase {
    channelsMap: { [id: number]: Channel };
    customerChannelsMap: { [id: number]: ChannelCustomerOperation };
}

export class AddChannelPage extends PageBase<AddChannelPagePageOptions> {
    private ddChannel: JQuery;
    private txtChannelUrl: HTMLInputElement;
    private selectChannelUrl: HTMLSelectElement;

    constructor(options: AddChannelPagePageOptions) {
        super(options);

        this.onChannelChange = this.onChannelChange.bind(this);
    }

    init(): void {
        this.ddChannel = $('#channel');
        this.ddChannel.on('change', this.onChannelChange);
        this.txtChannelUrl = (document.getElementById('textChannelUrl') as HTMLInputElement);
        this.selectChannelUrl = (document.getElementById('selectChannelUrl') as HTMLSelectElement);
        this.onChannelChange();
    }

    private onChannelChange(): void {
        var selectedItem = this.ddChannel.find(':selected');
        var channelId = parseInt(selectedItem.val());
        if (Number(channelId) <= 0) {
            return;
        }
        this.selectChannelUrl.options.length = 0;
        this.txtChannelUrl.value = '';

        var channelDefault = this._options.channelsMap[channelId];
        if (channelDefault) {
            let o = <HTMLOptionElement>(document.createElement('option'));
            o.value = channelDefault.Url;
            o.text = channelDefault.Url;
            this.selectChannelUrl.options.add(o);
            this.txtChannelUrl.value = channelDefault.Url;
        }
        for (let key in this._options.customerChannelsMap) {
            let channelCustomer = this._options.customerChannelsMap[key];
            if (!channelCustomer || channelCustomer.ChannelId !== channelId) {
                continue;
            }
            let o = <HTMLOptionElement>(document.createElement('option'));
            o.text = channelCustomer.Url;
            o.value = channelCustomer.Url;
            this.selectChannelUrl.options.add(o);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Customers/AddChannelPage.ts
 **/